import conditions from './smFurtherAction/smConditions';
import states from './smFurtherAction/smStates';
import defaultTransitions from './smFurtherAction/transitions/default/smTransitions';
import GAtransitions from './smFurtherAction/transitions/ga/smTransitions';
import IDtransitions from './smFurtherAction/transitions/id/smTransitions';
import MNLitetransitions from './smFurtherAction/transitions/mn/smTransitions_lite';
import MNtransitions from './smFurtherAction/transitions/mn/smTransitions';
import NJtransitions from './smFurtherAction/transitions/nj/smTransitions';
import NMtransitions from './smFurtherAction/transitions/nm/smTransitions';
import NVtransitions from './smFurtherAction/transitions/nv/smTransitions';
import PAtransitions from './smFurtherAction/transitions/pa/smTransitions';
import VAtransitions from './smFurtherAction/transitions/va/smTransitions';
import ILtransitions from './smFurtherAction/transitions/il/smTransitions';

// Centralized state-transitions map
const stateTransitionsMap = {
    ID: IDtransitions,
    IL: ILtransitions,
    OR: ILtransitions, // Oregon shares transitions with IL
    MN: MNtransitions,
    GA: GAtransitions,
    NM: NMtransitions,
    NJ: NJtransitions,
    PA: PAtransitions,
    VA: VAtransitions,
    NV: NVtransitions,
    GI: VAtransitions,
};
// non-full stack state-transtions map
const stateTransitionsNonFullStackMap = {
    MN: MNLitetransitions,
};

export default (state, isStateFullStack) => ({
    // smConditions and smStates are shared across all states
    states,
    conditions,
    transitions: isStateFullStack ? stateTransitionsMap[state] : (stateTransitionsNonFullStackMap[state] || stateTransitionsMap[state] || defaultTransitions)
});